import React from 'react'
import Hero from '../Components/Hero/Hero'


export default function Home() {
  return (
    <div>
       <Hero/>
    </div>
  )
}
